/**
 * Footer column accordion. docs/06 §6.3.
 *
 * Below 768 each link column folds behind its heading; at 768 and above every
 * panel is open and the heading is inert. docs/06 §6.3 keeps the brand block
 * and the bottom bar expanded at every width, which is why only columns that
 * rendered a heading button participate.
 *
 * The reference's accordion is logged as B15 — inferred from the class name
 * `.m-footer--accordion` and never actually exercised — so there was no
 * behaviour to copy. This is the accessible version of what the class name
 * implies.
 *
 * Progressive enhancement: with JS off every panel is visible, because the
 * collapsed state is only ever applied from here.
 */
(function () {
  const MOBILE = window.matchMedia('(max-width: 767px)');

  function apply(section) {
    const collapsible = MOBILE.matches;

    section.querySelectorAll('.footer__heading-button').forEach((button) => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;

      if (!collapsible) {
        // Above the breakpoint the heading is not a control. aria-disabled
        // rather than `disabled` so the heading text stays readable to a
        // screen reader — it is still the column's accessible name.
        button.setAttribute('aria-expanded', 'true');
        button.setAttribute('aria-disabled', 'true');
        button.tabIndex = -1;
        panel.hidden = false;
        return;
      }

      button.removeAttribute('aria-disabled');
      button.tabIndex = 0;
      // Preserve an open panel across a resize back down; default closed.
      const open = button.dataset.userOpened === 'true';
      button.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
    });
  }

  document.querySelectorAll('.footer').forEach((section) => {
    section.querySelectorAll('.footer__heading-button').forEach((button) => {
      button.addEventListener('click', () => {
        if (!MOBILE.matches) return;
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        button.dataset.userOpened = String(open);
        panel.hidden = !open;
      });
    });

    apply(section);
    MOBILE.addEventListener('change', () => apply(section));
  });
})();
